module.exports = __webpack_public_path__ + "img/MEDIA018.adf29f65.jpg";